import React, { Suspense, useEffect, lazy } from "react";
import { BrowserRouter as Router, useRoutes } from "react-router-dom";
import { PrimeReactProvider } from "primereact/api";
import { Provider } from "react-redux";
import store from "./store";

import { authProtectedRoutes, publicRoutes } from "./routes";
import AuthMiddleware from "./routes/route";

import "./assets/styles/ansa-theme.css";
import "./assets/styles/global.css";
import "./assets/styles/themes/main/theme.css";
import "./assets/styles/primereact.min.css";
import "primeicons/primeicons.css";
import { ToastProvider } from "./components/CustomToast";

// Lazy load NotFound component
const NotFound = lazy(() => import("./pages/NotFound"));


// Loading skeleton
const LoadingSkeleton = () => (
    <div className="flex items-center justify-center h-screen">
        <div className="p-4 text-center">
            <i className="pi pi-spinner pi-spin text-4xl text-primary"></i>
            <p>Loading...</p>
        </div>
    </div>
);

const AppRoutes = () => {
    const routes = [
        ...publicRoutes.map((route) => ({
            path: route.path,
            element: route.component,
        })),
        ...authProtectedRoutes.map((route) => ({
            path: route.path,
            element: (
                <AuthMiddleware>
                    {route.component}
                </AuthMiddleware>
            ),
        })),
        {
            path: "*",
            element: <NotFound />,
        },
    ];
    return useRoutes(routes);
};

const App = () => {
    useEffect(() => {
        const disableGestureZoom = (e) => {
            e.preventDefault();
        };
        
        document.addEventListener("gesturestart", disableGestureZoom, { passive: false });

        return () => {
            document.removeEventListener("gesturestart", disableGestureZoom);
        };
    }, []);

    return (
        <Provider store={store}>
            <PrimeReactProvider>
                <ToastProvider>
                    <Router>
                        <Suspense fallback={<LoadingSkeleton />}>
                            <AppRoutes />
                        </Suspense>
                    </Router>
                </ToastProvider>
            </PrimeReactProvider>
        </Provider>
    );
};

export default App;
